import {Module} from 'vuex';
import {AlertNotificationActions, EmployeeProfileActions, BioProfileActions, UrlActions} from './actions';
import {AlertNotificationGetters, EmployeeProfileGetters, BioProfileGetters, UrlGetters} from './getters';
import {AlertNotificationMutations, BioProfileMutations, EmployeeProfileMutations, UrlMutations} from './mutations';
import {AlertNotificationState, EmployeeProfileState, BioProfileState, UrlState} from './states';
import BioAdmin from 'types/ba/bioAdmin';
import LtFramework from 'types/lt/ltFramework';

export const AlertNotificationModule: Module<LtFramework.IAlertNotificationState, LtFramework.IRootState> = {
	namespaced: true,
	state: AlertNotificationState,
	getters: AlertNotificationGetters,
	actions: AlertNotificationActions,
	mutations: AlertNotificationMutations,
};

export const EmployeeProfileModule: Module<LtFramework.IEmployeeProfileState, LtFramework.IRootState> = {
	namespaced: true,
	state: EmployeeProfileState,
	getters: EmployeeProfileGetters,
	actions: EmployeeProfileActions,
	mutations: EmployeeProfileMutations,
};

export const BioProfileModule: Module<BioAdmin.IBioProfileState, LtFramework.IRootState> = {
	namespaced: true,
	state: BioProfileState,
	getters: BioProfileGetters,
	actions: BioProfileActions,
	mutations: BioProfileMutations,
};

export const UrlModule: Module<LtFramework.IUrlState, LtFramework.IRootState> = {
	namespaced: true,
	state: UrlState,
	getters: UrlGetters,
	actions: UrlActions,
	mutations: UrlMutations,
};
